export const ONBOARDING_STEP = "winona:onboarding-step";
